'use strict';exports.__esModule = true;exports.windDirectionsAmount = exports.mapWindDirection = undefined;var _pickBy = require('lodash/pickBy');var _pickBy2 = _interopRequireDefault(_pickBy);
var _keys = require('lodash/keys');var _keys2 = _interopRequireDefault(_keys);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var mapWindDirection = exports.mapWindDirection = function mapWindDirection(windDirection) {return (0, _keys2.default)(
  (0, _pickBy2.default)(windDirection, function (direction) {return !!direction;}));};


var windDirectionsAmount = exports.windDirectionsAmount = function windDirectionsAmount(windDirection) {return (
    mapWindDirection(windDirection).length);};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/windDirection.js
// module id = 3035
// module chunks = 0